import React, { useState, useEffect, Fragment } from 'react'
import {t} from 'i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Collapse, Card, CardBody, CardFooter } from 'reactstrap'
import { useRecoilState } from 'recoil'
import axios from 'axios'
import { Accordion } from 'react-bootstrap';

import env from '../../../env/src_config'
import { headersState } from '../../../recoil/recoil';
import Spinner from '../../spinner/Spinner'
import PaginationTop from '../../Pagination/PaginationTop'
import PaginationBottom from '../../Pagination/PaginationBottom'
import { axiosError } from '../../../helpers/response'
import { isNull } from '../../../izUtils'
import { transformer } from '../../../helpers/fields'
import FacilityList from './lists/FacilityList'
import Filter from '../../filters/Filter'
import DictionaryInfoButton from '../../dictionary/DictionaryInfoButton'

const FacilitiesTable = () => {
    const Navigate = useNavigate();
    const [headers] = useRecoilState(headersState);
    const { clientId } = useParams();

    const [isOpen, setIsOpen] = useState(null);
    const [isFilterOpen, setIsFilterOpen] = useState(null);
    const [facilities, setFacilities] = useState(null)
    const [filters, setFilters] = useState(null)

    const lsFilterName = 'AKODA.facilityFilter';

    useEffect(() => {
        getFacilities({ client: {value: clientId} });

        return () => {
            localStorage.removeItem(lsFilterName)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId])

    const getFacilities = (passedFilters) => {
        const keys = Object.keys(passedFilters);
        let payload = { filters: {} };
        for (let i = 0; i < keys.length; i++) {
            if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                payload.filters[keys[i]] = passedFilters[keys[i]].value;
            } else {
                payload.filters[keys[i]] = "";
            }
        }

        axios.post(env.api + '/api/client/facility/list', payload, {headers}).then(response => {
            if (!isNull(response.data.data)) {
                setFacilities(response.data.data);
                if (!isNull(response.data.filters)) {
                    setFilters(transformer(response.data.filters));
                    localStorage.setItem(lsFilterName, JSON.stringify(transformer(response.data.filters)))
                }
            }
        }).catch(error => {
            axiosError(error, Navigate);
        });
    }


    const clearData = () => {
        localStorage.removeItem(lsFilterName);
        getFacilities({ client: {value: clientId} });
    }

    if (isNull(facilities)) {
        return <Spinner />
    } else {
        const filterFields = [/*'client',*/ 'name', 'location', 'facility_number']
        return (
          <Fragment>
            <Card className="ribbon-wrapper">
                <div className="ribbon ribbon-clip ribbon-primary">
                    <div className='d-flex align-items-center'>
                        {t('clients.facilities.list.title')}
                        <DictionaryInfoButton code="client_facilities.list.title" id="client_facilities.list.title" />
                    </div>
                </div>
                <Accordion>
                    <div className='p-3'>
                        <Button color="secondary" className="card-collapse-button" data-toggle="collapse" onClick={() => setIsOpen(!isOpen)}>
                            <div className={'filter-icon' + (isOpen ? ' rotate-icon' : '')}>
                                <i className="fa fa-chevron-down"></i>
                            </div>
                        </Button>
                    </div>
                    <Collapse isOpen={isOpen}>
                        <CardBody>
                            <Accordion className='mb-3'>
                                <div className="default-according style-1" id="facilitieFilter">
                                    <Button color="secondary" className="acc-btn d-flex justify-content-between align-items-center" data-toggle="collapse" onClick={() => setIsFilterOpen(!isFilterOpen)}>
                                        {t('filters')}
                                        <div className={'filter-icon' + (isFilterOpen ? ' rotate-icon' : '')}>
                                            <i className="fa fa-chevron-down"></i>
                                        </div>
                                    </Button>
                                    <Collapse isOpen={isFilterOpen}>
                                        <div className='p-3'>
                                            <Filter filterFields={filterFields} filters={filters} getData={(clonedFilters) => getFacilities(clonedFilters)} lsFilterName={lsFilterName} clearData={clearData} />
                                        </div>
                                    </Collapse>
                                </div>
                            </Accordion>
                            <PaginationTop filters={filters} getData={clonedFilters => getFacilities(clonedFilters)} />
                            <FacilityList data={facilities} headers={headers}/>
                            <PaginationBottom filters={filters} getData={clonedFilters => getFacilities(clonedFilters)} />
                        </CardBody>
                        <CardFooter>
                            <div className='text-end'>
                                <div className='d-flex align-items-center mt-2'>
                                    <Button color="primary" className="me-2" onClick={() => Navigate('/clients/' + clientId + '/facilities/create')}>{t('clients.facilities.list.addNew')}</Button>
                                    <DictionaryInfoButton code="client_facilities.list.add" id="client_facilities.list.add" />
                                </div>
                            </div>
                        </CardFooter>
                    </Collapse>
                </Accordion>
            </Card>
          </Fragment>
        )
    }
}

export default FacilitiesTable